import type { IReportColumn } from '~/presentation/reports/common/Visualization/types';
import type { OrderByFields } from '../../types';

import { ArrowDownIcon, ArrowUpIcon } from '@shopify/polaris-icons';
import { GButton, GTooltipCard } from '~/presentation/ui';
import { InlineStack, Text } from '@shopify/polaris';
import { getOrderTooltip } from '../../utils/order';
import { EOrderDirectionType } from '../../types';

interface ISortableHeaderWithTooltipProps {
  item: IReportColumn;
  orderBy?: OrderByFields;
  onChangeOrderBy?: (field: string) => void;
}

export const SortableHeaderWithTooltip = ({
  item,
  orderBy,
  onChangeOrderBy,
}: ISortableHeaderWithTooltipProps) => {
  const { displayName, name, tooltipCardProps } = item;

  return (
    <InlineStack gap="050" blockAlign="center">
      <GTooltipCard {...tooltipCardProps}>
        <Text as="span" variant="bodySm" fontWeight="medium" truncate tone="subdued">
          {displayName}
        </Text>
      </GTooltipCard>

      {hasOrderByName(name) && (
        <div className="-mb-1">
          <GButton
            variant="plain"
            icon={getOrderIcon(name)}
            tooltip={getSortTooltip(name)}
            onClick={() => onChangeOrderBy?.(name)}
          />
        </div>
      )}
    </InlineStack>
  );

  function hasOrderByName(name: string) {
    const orderByField = orderBy?.[name];
    return !!orderByField;
  }

  function getSortTooltip(name: string) {
    const orderByField = orderBy?.[name];
    if (!hasOrderByName(name) || !orderByField) return undefined;

    const content = getOrderTooltip(name, orderByField?.direction);

    return { content };
  }

  function getOrderIcon(name: string) {
    const orderByField = orderBy?.[name];
    if (!orderByField) return ArrowUpIcon;

    return orderByField.direction === EOrderDirectionType.ASC ? ArrowUpIcon : ArrowDownIcon;
  }
};
